import * as amplitude from "@amplitude/analytics-browser";
import { environment } from "@app/dashboard/environments/environment";

type AmplitudePropertiesObject = { [key: string]: any };

export const amplitudeInit = () => {
  amplitude.init(environment.AMPLITUDE_API_KEY, {
    autocapture: false,
    minIdLength: 1
  });
};


export const amplitudeSetProperty = (
  properties: string | AmplitudePropertiesObject,
  value?: any
) => {
  const amplitudeProperties = new amplitude.Identify();

  if (typeof properties === 'string' && value !== undefined) {

    // Single property-value pair
    amplitudeProperties.set(properties, value);
    amplitude.identify(amplitudeProperties);

  } else if (typeof properties === 'object' && properties !== null) {

    // Multiple properties and values
    Object.entries(properties).forEach((entry) => {
      const [key, value] = entry;
      key && value && amplitudeProperties.set(key, value);
    })
    amplitude.identify(amplitudeProperties);

  } else {
    console.error('Invalid arguments provided to "amplitudeSetProperty"');
  }
};
